import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import '../inputs.scss';

const ApartmentInput = ({
    hasError = false,
    placeholder = 'Квартира',
    value, onChange,
}) => {
    const inputClasses = classNames({
        'input input--apartment': true,
        'has-error': hasError,
    });

    return (
        <label htmlFor="apartment" styleName="input--has-float-label">
            <input
                styleName={inputClasses}
                type="tel"
                id="apartment"
                name="apartment"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                maxLength={8}
            />
            <div styleName="input__label">{placeholder}</div>
        </label>
    );
};

export default ApartmentInput;

ApartmentInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool,
    placeholder: PropTypes.string,
};
